import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { productPageUrl, productPageTheme, shopNowLink } from '../../config/pageConfig';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { LangText } from './LangText';
import getLocal from '@/app/utils/i18n';

export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const { locale } = getLocal();
    const { pathname } = useRouter();
    const TextA = LangText[locale] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const linkMap = shopNowLink[locale];
    const isInProductPage = pathname.endsWith(productPageUrl);

    const tabChange = (item: any, index: number) => {
        tabCallback && tabCallback(item.value);
    };

    const data: EcoNavProductProps = {
        productItems: [
            {
                value: 'd3a',
                label: TextA.product_name,
                href: thePageUrl,
            },
        ],
        tabItems: [
            {
                value: 'Product',
                label: TextA.tab_product,
                href: isInProductPage ? undefined : thePageUrl,
            },
            {
                value: 'Specs',
                label: TextA.tab_specs,
                href: `${thePageUrl}/specs`,
            },
            {
                value: 'Support',
                label: TextA.tab_support,
                href: `${thePageUrl}/support`,
            },
        ],
        buyItems: [
            {
                value: 'Button',
                label: TextA.btn_buy,
                href: linkMap.nav,
            },
        ],
        dataLayerBuy: {
            event: 'uaEvent',
            event_name: 'buy',
            product_name: TextA.product_name,
            position: TextA.product_name,
            __btn_id1: '__buy-1',
            __btn_type: 'common',
            __btn_id2: TextA.btn_buy,
        },
        theme: productPageTheme,
        onTabChange: tabChange,
        defaultTabActiveKey: activeTab,
    };

    return (
        <div className={styles.comp}>
            <EcoNavProduct {...data} />
        </div>
    );
}
